import React from 'react';
import withIcon from '../utilities/withIcon';

const IconGlobe = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm2.191 11.002H5.81C6.262 13.094 7.148 14.5 8 14.5c.852 0 1.738-1.406 2.191-3.498zM4.273 11h-2.04a6.527 6.527 0 0 0 3.001 2.883c-.376-.708-.676-1.564-.886-2.52L4.273 11zm9.494 0h-2.04c-.21 1.102-.538 2.086-.96 2.883a6.531 6.531 0 0 0 2.864-2.634l.136-.249zm-9.702-4.5H1.674a6.518 6.518 0 0 0 0 3h2.392a17.003 17.003 0 0 1 0-3zm6.36-.001h-4.85a15.066 15.066 0 0 0 0 3.001h4.85a15.065 15.065 0 0 0 0-3.001zm3.901 0h-2.391a17.004 17.004 0 0 1 0 3h2.39a6.518 6.518 0 0 0 .001-3zM5.234 2.116l-.064.03A6.528 6.528 0 0 0 2.232 5h2.04c.212-1.103.539-2.087.962-2.884zM8 1.5l-.096.006c-.822.1-1.659 1.479-2.095 3.493h4.382C9.756 2.99 8.923 1.614 8.102 1.507L8 1.5zm2.766.616.077.148c.386.77.686 1.701.884 2.736h2.04a6.527 6.527 0 0 0-3.001-2.884z" />
    </g>
  );
};

export default withIcon(IconGlobe);
